/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Phoenix | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateListPageViewRequest,
  GetListPageStateResponse,
  SetListPageUserStateRequest,
  SetListPageViewDisplayRequest,
  UpdateListPageViewRequest
} from '.././schemas';

import { customInstance } from '../../customInstance';
import type { ErrorType } from '../../customInstance';




export const updateListPageView = (
    id: string,
    updateListPageViewRequest: UpdateListPageViewRequest,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/list-pages/views/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateListPageViewRequest
    },
      );
    }
  


export const getUpdateListPageViewMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateListPageView>>, TError,{id: string;data: UpdateListPageViewRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateListPageView>>, TError,{id: string;data: UpdateListPageViewRequest}, TContext> => {

const mutationKey = ['updateListPageView'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateListPageView>>, {id: string;data: UpdateListPageViewRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  updateListPageView(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateListPageViewMutationResult = NonNullable<Awaited<ReturnType<typeof updateListPageView>>>
    export type UpdateListPageViewMutationBody = UpdateListPageViewRequest
    export type UpdateListPageViewMutationError = ErrorType<unknown>

    export const useUpdateListPageView = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateListPageView>>, TError,{id: string;data: UpdateListPageViewRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateListPageView>>,
        TError,
        {id: string;data: UpdateListPageViewRequest},
        TContext
      > => {

      const mutationOptions = getUpdateListPageViewMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const deleteListPageView = (
    id: string,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/list-pages/views/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteListPageViewMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteListPageView>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteListPageView>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteListPageView'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteListPageView>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteListPageView(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteListPageViewMutationResult = NonNullable<Awaited<ReturnType<typeof deleteListPageView>>>
    
    export type DeleteListPageViewMutationError = ErrorType<unknown>

    export const useDeleteListPageView = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteListPageView>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteListPageView>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteListPageViewMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const setListPageViewDisplay = (
    id: string,
    setListPageViewDisplayRequest: SetListPageViewDisplayRequest,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/list-pages/views/${id}/display`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setListPageViewDisplayRequest
    },
      );
    }
  


export const getSetListPageViewDisplayMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setListPageViewDisplay>>, TError,{id: string;data: SetListPageViewDisplayRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof setListPageViewDisplay>>, TError,{id: string;data: SetListPageViewDisplayRequest}, TContext> => {

const mutationKey = ['setListPageViewDisplay'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setListPageViewDisplay>>, {id: string;data: SetListPageViewDisplayRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  setListPageViewDisplay(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SetListPageViewDisplayMutationResult = NonNullable<Awaited<ReturnType<typeof setListPageViewDisplay>>>
    export type SetListPageViewDisplayMutationBody = SetListPageViewDisplayRequest
    export type SetListPageViewDisplayMutationError = ErrorType<unknown>

    export const useSetListPageViewDisplay = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setListPageViewDisplay>>, TError,{id: string;data: SetListPageViewDisplayRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setListPageViewDisplay>>,
        TError,
        {id: string;data: SetListPageViewDisplayRequest},
        TContext
      > => {

      const mutationOptions = getSetListPageViewDisplayMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getListPageState = (
    listPageKey: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetListPageStateResponse>(
      {url: `/api/list-pages/${listPageKey}/state`, method: 'GET', signal
    },
      );
    }
  



export const getGetListPageStateQueryKey = (listPageKey?: string,) => {
    return [
    `/api/list-pages/${listPageKey}/state`
    ] as const;
    }

    
export const getGetListPageStateQueryOptions = <TData = Awaited<ReturnType<typeof getListPageState>>, TError = ErrorType<unknown>>(listPageKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListPageState>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetListPageStateQueryKey(listPageKey);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getListPageState>>> = ({ signal }) => getListPageState(listPageKey, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(listPageKey), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getListPageState>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetListPageStateQueryResult = NonNullable<Awaited<ReturnType<typeof getListPageState>>>
export type GetListPageStateQueryError = ErrorType<unknown>


export function useGetListPageState<TData = Awaited<ReturnType<typeof getListPageState>>, TError = ErrorType<unknown>>(
 listPageKey: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListPageState>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getListPageState>>,
          TError,
          Awaited<ReturnType<typeof getListPageState>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetListPageState<TData = Awaited<ReturnType<typeof getListPageState>>, TError = ErrorType<unknown>>(
 listPageKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListPageState>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getListPageState>>,
          TError,
          Awaited<ReturnType<typeof getListPageState>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetListPageState<TData = Awaited<ReturnType<typeof getListPageState>>, TError = ErrorType<unknown>>(
 listPageKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListPageState>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetListPageState<TData = Awaited<ReturnType<typeof getListPageState>>, TError = ErrorType<unknown>>(
 listPageKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListPageState>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetListPageStateQueryOptions(listPageKey,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const setListPageUserState = (
    listPageKey: string,
    setListPageUserStateRequest: SetListPageUserStateRequest,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/list-pages/${listPageKey}/user-state`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setListPageUserStateRequest
    },
      );
    }
  


export const getSetListPageUserStateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setListPageUserState>>, TError,{listPageKey: string;data: SetListPageUserStateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof setListPageUserState>>, TError,{listPageKey: string;data: SetListPageUserStateRequest}, TContext> => {

const mutationKey = ['setListPageUserState'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setListPageUserState>>, {listPageKey: string;data: SetListPageUserStateRequest}> = (props) => {
          const {listPageKey,data} = props ?? {};

          return  setListPageUserState(listPageKey,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SetListPageUserStateMutationResult = NonNullable<Awaited<ReturnType<typeof setListPageUserState>>>
    export type SetListPageUserStateMutationBody = SetListPageUserStateRequest
    export type SetListPageUserStateMutationError = ErrorType<unknown>

    export const useSetListPageUserState = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setListPageUserState>>, TError,{listPageKey: string;data: SetListPageUserStateRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setListPageUserState>>,
        TError,
        {listPageKey: string;data: SetListPageUserStateRequest},
        TContext
      > => {

      const mutationOptions = getSetListPageUserStateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const createListPageView = (
    listPageKey: string,
    createListPageViewRequest: CreateListPageViewRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/api/list-pages/${listPageKey}/views`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createListPageViewRequest, signal
    },
      );
    }
  


export const getCreateListPageViewMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createListPageView>>, TError,{listPageKey: string;data: CreateListPageViewRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createListPageView>>, TError,{listPageKey: string;data: CreateListPageViewRequest}, TContext> => {

const mutationKey = ['createListPageView'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createListPageView>>, {listPageKey: string;data: CreateListPageViewRequest}> = (props) => {
          const {listPageKey,data} = props ?? {};

          return  createListPageView(listPageKey,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateListPageViewMutationResult = NonNullable<Awaited<ReturnType<typeof createListPageView>>>
    export type CreateListPageViewMutationBody = CreateListPageViewRequest
    export type CreateListPageViewMutationError = ErrorType<unknown>

    export const useCreateListPageView = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createListPageView>>, TError,{listPageKey: string;data: CreateListPageViewRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createListPageView>>,
        TError,
        {listPageKey: string;data: CreateListPageViewRequest},
        TContext
      > => {

      const mutationOptions = getCreateListPageViewMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    